/*
* <license header>
*/

import React from 'react'
import { Heading, Text, View } from '@adobe/react-spectrum'

const FieldCell = ({ label, value, isLink }) => {
  if (!value) return null
  const displayValue = Array.isArray(value) ? value.join(', ') : value
  return (
    <View UNSAFE_style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <Text UNSAFE_style={{ fontSize: '0.7rem', fontWeight: 600, color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '0.25rem' }}>
        {label}
      </Text>
      {isLink && displayValue ? (
        <a
          href={displayValue}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '0.75rem', color: 'var(--spectrum-global-color-blue-600)', wordBreak: 'break-all', textDecoration: 'none', lineHeight: 1.4 }}
        >
          {displayValue}
        </a>
      ) : (
        <Text UNSAFE_style={{ fontSize: '0.8rem', color: 'var(--gray-700)', lineHeight: 1.4 }}>
          {displayValue}
        </Text>
      )}
    </View>
  )
}

export const TemplateCard = ({ title, badge, description, githubUrl, useCase, appBuilderType, technologies }) => {
  return (
    <View
      UNSAFE_style={{
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1.25rem',
        backgroundColor: 'var(--white)',
        minHeight: '14rem',
        flex: 1,
        width: '100%',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <View
        UNSAFE_style={{
          height: '16rem',
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <View
          UNSAFE_style={{
            display: 'inline-block',
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            backgroundColor: 'var(--card-accent)',
            color: 'white',
            fontSize: '0.75rem',
            fontWeight: 600,
            marginBottom: '0.75rem',
            alignSelf: 'flex-start'
          }}
        >
          {badge}
        </View>
        <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1rem', lineHeight: 1.3 }}>
          {title}
        </Heading>
        <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.8rem', lineHeight: 1.45, flex: 1, overflow: 'auto', minHeight: 0 }}>
          {description}
        </Text>
      </View>
      <View
        UNSAFE_style={{
          borderTop: '1px solid var(--gray-200)',
          paddingTop: '0.75rem',
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}
      >
        <FieldCell label="GitHub Repository" value={githubUrl} isLink />
        <FieldCell label="Use Cases" value={useCase} />
        <FieldCell label="App Builder Type" value={appBuilderType} />
        <FieldCell label="Technologies" value={technologies} />
      </View>
    </View>
  )
}
